import { b as __makeTemplateObject } from './_tslib-4c7d6ae2.js';
import debounce from 'lodash/debounce';
import * as React from 'react';
import { useSwipeable } from 'react-swipeable';
import { CSSTransition } from 'react-transition-group';
import { C as Cross } from './Cross-2c127383.js';
import { u as useEscButton } from './useEscButton-73ea94fa.js';
import { u as useHistoryBack } from './useHistoryBack-a0e15180.js';
import { u as usePreventScroll } from './usePreventScroll-9ab469ed.js';
import clsx from 'clsx';
import { createGlobalStyle } from 'styled-components';
import { O as Overlay, C as Content, a as CloseButton } from './SlideStyles-8cb1c71e.js';

var SlideLeftStyles = createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    .slide-left {\n        &-enter {\n            transform: translate3D(100%, 0, 0);\n            &-active {\n                transform: none;\n            }\n        }\n\n        &-exit {\n            transform: none;\n            &-active,\n            &-done {\n                transform: translate3D(100%, 0, 0);\n            }\n        }\n    }\n"], ["\n    .slide-left {\n        &-enter {\n            transform: translate3D(100%, 0, 0);\n            &-active {\n                transform: none;\n            }\n        }\n\n        &-exit {\n            transform: none;\n            &-active,\n            &-done {\n                transform: translate3D(100%, 0, 0);\n            }\n        }\n    }\n"])));
var SlideLeftTransition = function (_a) {
    var isVisible = _a.isVisible, children = _a.children, onClose = _a.onClose, _b = _a.unmountOnExit, unmountOnExit = _b === void 0 ? true : _b, _c = _a.mountOnEnter, mountOnEnter = _c === void 0 ? true : _c, _d = _a.showCloseButton, showCloseButton = _d === void 0 ? true : _d, _e = _a.closeOnBackButton, closeOnBackButton = _e === void 0 ? true : _e, _f = _a.fullscreen, fullscreen = _f === void 0 ? false : _f, _g = _a.Variant, Variant = _g === void 0 ? "" : _g, _h = _a.hideOverlay, hideOverlay = _h === void 0 ? false : _h;
    // Actions to close
    useEscButton(onClose, isVisible);
    if (closeOnBackButton) {
        useHistoryBack(onClose, isVisible);
    }
    // Swiping left interaction
    var _j = React.useState(0), currentDeltaX = _j[0], setDeltaX = _j[1];
    var _k = useSwipeable({
        onSwipedLeft: debounce(function (_a) {
            var velocity = _a.velocity, event = _a.event;
            setDeltaX(0);
            var root = document.getElementById("slide-left");
            if (velocity > 0.5 && event.target === root) {
                onClose();
            }
        }, 500, { leading: true }),
        onSwiping: function (_a) {
            var deltaX = _a.deltaX, event = _a.event;
            var root = document.getElementById("slide-left");
            if (!root || root.scrollLeft > 0 || event.target !== root) {
                return;
            }
            setDeltaX(deltaX);
        },
    }), swipeableRef = _k.ref, onMouseDown = _k.onMouseDown;
    var getTransforms = function () {
        if (currentDeltaX >= 0) {
            return undefined;
        }
        return {
            transform: "translate3d(".concat(currentDeltaX * -1, "px, 0, 0)"),
            transition: "none",
        };
    };
    // Prevent background scrolling
    var _l = React.useState(isVisible), preventScroll = _l[0], setPreventScroll = _l[1];
    var slideLeftRoot = React.useRef();
    React.useEffect(function () { return setPreventScroll(isVisible || preventScroll); }, [isVisible, preventScroll]);
    usePreventScroll({ scrollEnabled: !preventScroll, exclude: slideLeftRoot.current });
    var ref = function (div) {
        swipeableRef(div);
        slideLeftRoot.current = div;
    };
    // Layout
    return (React.createElement(React.Fragment, null,
        React.createElement(SlideLeftStyles, null),
        isVisible && React.createElement(Overlay, { hideOverlay: hideOverlay, "data-testid": "backdrop", onClick: onClose }),
        React.createElement(CSSTransition, { classNames: "slide-left", appear: true, in: isVisible, timeout: 400, unmountOnExit: unmountOnExit, mountOnEnter: mountOnEnter, onExited: function () { return setPreventScroll(false); } },
            React.createElement(Content, { className: clsx({ "--fullscreen": fullscreen }, Variant), id: "slide-left", "data-testid": "root", ref: ref, onMouseDown: onMouseDown, style: getTransforms() },
                showCloseButton && (React.createElement(CloseButton, { "data-testid": "close_button", onClick: onClose },
                    React.createElement(Cross, null))),
                children))));
};
var templateObject_1;

export { SlideLeftTransition as S };
//# sourceMappingURL=SlideLeftTransition-22f36800.js.map
